import styled from "styled-components";
import { ReactComponent as SvgCircle } from "../../assets/svg/bg-circle-3.svg";
import { svgBgCompSharedStyles } from "../../config/theme/mixins";

export const SvgBgCircleRed = styled(SvgCircle)`
  ${svgBgCompSharedStyles};
`;
